// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/aac2a506/" + chunkId + "." + __webpack_require__.h() + ".vaac2a506.js";
};